import React, { useMemo } from "react";
import { ICitation } from "system/types/interfaces";

interface IProps {
  citations?: ICitation[];
}

// Extensions to exclude
const blockedExtensions = [".xls", ".xlsx", ".xlsm", ".png", ".jpg", ".jpeg", ".gif", ".svg", ".webp"];

export const CitationReferencesComponent = ({ citations }: IProps) => {
  const filteredCitations = useMemo(() => {
    if (!citations || citations.length === 0) {
      return [];
    }

    return citations.filter((citation) => {
      try {
        const url = citation?.url;
        if (typeof url === "string") {
          const pathname = new URL(url).pathname.toLowerCase();
          return !blockedExtensions.some((ext) => pathname.endsWith(ext));
        }
      } catch (error) {
        console.warn("Invalid citation URL:", citation?.url);
      }

      return false;
    });
  }, [citations]);

  if (filteredCitations.length === 0) {
    return null;
  }

  return (
    <div className="citations-area">
      <span className="learn-more-text">Learn More:</span>
      <div className="citation-references-container">
        {filteredCitations.map((citation, index) => (
          <a
            className="citation-reference"
            title={citation.displayText}
            key={citation.citationId}
            rel="noreferrer"
            target="_blank"
            href={citation.url}
          >
            {index + 1}. {citation.displayText}
          </a>
        ))}
      </div>
    </div>
  );
};
